// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d694b00b","186":"191c4509","225":"a5a57217","344":"49ce38ec","372":"8dc626b8","377":"71b3bd2a","443":"3b4b8208","841":"e0f95f71","856":"e1ce52ef","858":"bf65ea89"}[chunkId] + ".chunk.js";
};